<template>
  <div class="cc-full-leaderboard-admin">
    <table class="form-table">
      <tr>
        <th>Events</th>
        <td>
          <EventTable :events="settings.events"/>
        </td>
      </tr>
      <tr>
        <th>Show Top # Competitors</th>
        <td>
          <select v-model="settings.topX">
            <option v-for="value in [
              {value:5, text: 5},
              {value:10, text: 10},
              {value:15, text: 15},
              {value:20, text: 20},
              {value:9999, text: 'Show All'},
              ]" :value="value.value" :key="value.value">{{ value.text }}</option>
          </select>
        </td>
      </tr>
      <tr>
        <th>Max Height</th>
        <td><input type="text" v-model="settings.maxHeight"/></td>
      </tr>
      <tr>
        <th>Primary Color</th>
        <td><input type="text" v-model="settings.primaryColor"/></td>
      </tr>
      <tr>
        <th>Secondary Color</th>
        <td><input type="text" v-model="settings.secondaryColor"/></td>
      </tr>
      <tr>
        <th>Font Size</th>
        <td><input type="text" v-model="settings.fontSize"/></td>
      </tr>
      <tr>
        <th>Font Family</th>
        <td>
          <div style="position: relative; width: 250px">
            <input type="text" v-model="settings.font" @focus="showfonts = true" @blur="showfonts = false" style="width: 100%"/>
            <ul v-if="showfonts" class="fonts-list" style="position: absolute; width: 100%">
              <li v-for="(font,index) in getFontList" :key="index" :value="font.family" @mousedown="settings.font = font.family">{{ font.family }}</li>
            </ul>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import EventTable from './components/EventTable'
export default {
  data () {
    return {
      showfonts: false,
      settings : {
        events: [],
        topX: 10,
        maxHeight: 400,
        primaryColor: '',
        secondaryColor: '',
        font: '',
        fontSize: '14px',
        isGoogleFont: false,
      },
      fonts: cc_full_leaderboard_settings.fonts
    }
  },
  components: {
    EventTable
  },
  mounted () {
    if(document.getElementsByName("cc_full_leaderboard_options")[0].value){
      this.settings = JSON.parse(document.getElementsByName("cc_full_leaderboard_options")[0].value);
    }
    this.settings.events.sort((a, b) => {
      return a.weight > b.weight
    })
  },
  computed: {
    getFontList () {
      return cc_full_leaderboard_settings.fonts.filter(font => {
        return font.family.toLowerCase().indexOf(this.settings.font.toLowerCase()) !== -1;
      })
    }
  },
  watch: {
    settings: {
      handler: function (val, oldVal) {
        document.getElementsByName("cc_full_leaderboard_options")[0].value = JSON.stringify(val);
      },
      deep: true
    },
    'settings.font' (val) {
      if(val){
        let selectFont = this.fonts.find(e => {
          return e.family === val
        });
        if(selectFont){
          this.settings.isGoogleFont = typeof selectFont.kind == 'undefined' ? false : true
        }else{
          this.settings.isGoogleFont = false;
        }
        console.log( this.settings.isGoogleFont)
      }
    }
  }
}
</script>
<style scoped>
  ul.fonts-list{
    position: absolute;
    width: 100%;
    background: #fff;
    padding: 5px 6px;
    box-sizing: border-box;
    list-style: none;
    margin: 0 0 0 1px;
    border: 1px solid #ddd;
    top: 26px;
    left: 0;
    max-height: 300px;
    overflow: auto;
    z-index: 99;
  }
  ul.fonts-list li:hover{
    background: #eee;
  }
</style>
